<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="票券訂單查詢"
      fkey="om01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div class="wrapper2" ref="wrapper" @scroll="handleScroll">
      <b-table :stacked="checkMobile()" ref="scrollarea" class="" striped hover :items="items" :fields="fields" @scrolldownend="searchOrders(true)" show-empty >
        <template slot="empty">
          目前都沒有資料喔
        </template>

        <!-- 自訂status -->
        <template v-slot:cell(order_status)="row">
          <span v-if="row.item.order_status === 'declined'">
            <p>{{row.item.order_status}}</p>
            <p style="color: red; font-size:14px;">請檢查課程設定</p>
          </span>
          <span v-else>
            {{row.item.order_status}}
          </span>
        </template>
        
        <template v-slot:cell(paper_way)="row">
          {{row.item.paper_way}}{{row.item.ext_ns_synced==0?'(待拋NS)':''}}{{row.item.ext_ns_synced==1?'(已拋NS)':''}}{{row.item.ext_ns_synced==2?'(已入NS)':''}}{{row.item.ext_ns_synced==-99?'(異常)':''}}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button @click="showDetail(row.item)">詳細</b-button>
          <b-button v-if="row.item.is_shopline_order&&row.item.order_status!='cancelled'" @click="cancelOrder(row.item)">取消作廢</b-button>
          <b-button v-show="[-1,2,-99].includes(row.item.ext_ns_synced)==false&&row.item.order_status!='cancelled'" @click="reSyncExtOrdToNS(row.item)">{{row.item.ext_ns_synced==0?'手拋NS':'重拋NS'}}</b-button>
          <b-button v-show="row.item.order_status=='processing'&&row.item.failed_times>=5" @click="restartOrder(row.item)">重啟取號</b-button>
        </template>
      </b-table>
    </div>
    <b-modal
      id="detailModal"
      ref="ticketModal"
      v-model="modalShow" 
      centered
      size="xl"
      hide-header
      hide-footer
      :static="true"
    >
      <b-table :stacked="checkMobile()" :items="view_order_items" :fields="order_item_fields">
        <template v-slot:cell(show_tickets)="row">
          <!--這一段UI怎麼呈現要再想一下-->
          <b-button v-show="row.item.item_type=='ticket_item'" @click="showTickets(row)">顯示票券</b-button>
        </template>
        <template #row-details="row" >
          {{row.item.product_id}}的票券處理：
          <ul>
            <li style="text-align:left;margin-bottom:5px;" v-for="(ticket, idx) in row.item.tickets" :key="ticket.ticket_unique_id">
              <span v-show="ticket.confirm_use_status==='requesting'">{{ticket.ticket_id}}票券取號未完成</span>
              <span v-show="ticket.confirm_use_status!=='requesting'">{{ticket.ticket_no ? ticket.ticket_no : ticket.ticket_id }}&nbsp;&nbsp;{{ticket.print_time}}&nbsp;{{ticket.confirm_use_status}}</span>
              <b-button class="ml-1" v-show="ticket.confirm_use_status=='running' || ticket.confirm_use_status=='requesting'" :disabled="ticket.ticket_id.startsWith('TT')||['賴酷'].includes(view_order_type)" @click="trash_ticket(ticket,row)" >手動作廢{{ticket.ticket_id.startsWith('TT')?'(mana產票暫不允許由此作廢)':''}}</b-button>
              <!-- <span v-show="ticket.confirm_use_status=='running'&&['賴酷'].includes(view_order_type)">(尚峪電子票作廢請串接api作廢)</span> -->
              <div v-show="ticket.is_canceling === true">
                確認作廢此票(暫時先用票號input,之後再改成確認掃描成功)
                <b-input v-if="ticket.ticket_no" v-model="ticket.ticket_no" style="margin:auto;width:300px;text-align:center;" placeholder="再輸入一次作廢的票號(掃描票券條碼)"></b-input>
                <b-input v-else v-model="ticket.ticket_id" style="margin:auto;width:300px;text-align:center;" placeholder="再輸入一次作廢的票號(掃描票券條碼)"></b-input>
                <b-button class="mr-2" @click="cancelTrash(row, ticket,idx)">取消</b-button>
                <b-button @click="confirm_trash">確認作廢{{row.item.ticket_id}}</b-button>
                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="warning"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                ></b-alert>
              </div>
            </li>
          </ul>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import {
  apiSearchTicketOrders,
  apiVerifyNSOrdSynced,
  apiCancelPaperTicket,
  apiCancelTickets,
  apiRestartFailedOrder,
  apiReSyncExtOrdToNS,
  apiCancelSpecialTickets
} from '@/api/Order.js'

export default {
  name: 'OrderProcess',
  components: {
  
  },
  data: function () {
    return {
      dismissCountDown:0,
      dismissSecs:3,
      filterData: {},
      filterOptions: [
        {
          componentType:'text',
          defaultValue:'',
          akey:'order_id',
          col:3,
          placeholder:'訂單編號',
          execCallback:this.searchOrders,
        },
        {
          componentType:'date-picker',
          defaultValue:'',
          akey:'date_from',
          col:3,
          placeholder:'篩選下單日期起',
          execCallback:this.searchTickets,
        },
        {
          componentType:'date-picker',
          defaultValue:'',
          akey:'date_to',
          col:3,
          placeholder:'篩選下單日期迄',
          execCallback:this.searchTickets,
        },
        {
          componentType:'text',
          defaultValue:'',
          akey:'member_id',
          col:3,
          placeholder:'購買人MI',
          execCallback:this.searchOrders,
        },
        {
          componentType:'b-form-select',
          akey:'status',
          col:3,
          defaultValue:'',
          dataOptions:[{value:'',text:'全部訂單處理狀態'},{value:'processing',text:'processing-電子票訂單處理中'},{value:'completed',text:'completed-電子票訂單已處理'},{value:'accepted',text:'accepted-紙本票訂單待處理'},{value:'printed_to_deliver',text:'printed_to_deliver-紙本票訂單已下載pdf'},{value:'cancelled',text:'cancelled-訂單已取消'},{value:'external_processed',text:'external_processed-mana已代產紙本訂單'},{value:'undefined',text:'undefined-其他未定義來源訂單狀態'}],
          placeholder:'篩選訂單狀態',
          execCallback:this.searchOrders,
        },
        {
          componentType:'b-form-select',
          akey:'print_type',
          col:3,
          defaultValue:'',
          dataOptions:[{value:'',text:'全部訂單類型'},{value:'ELC',text:'電子票'},{value:'LNC',text:'賴酷券'},{value:'Paper',text:'紙本票不混商品'},{value:'Other',text:'紙本票混商品'},{value:'KTC',text:'智生活紙本票'}],
          placeholder:'篩選訂單類型',
          execCallback:this.searchOrders,
        },
        {
          componentType:'text',
          akey:'ord_amt_sum',
          col:3,
          placeholder:'查詢訂單加總',
          disabled:true
        },
        {
          componentType:'b-form-checkbox',
          col:1,
          akey:'cal_only_synced',
          placeholder:'已拋'
        },
        {
          componentType:'b-button',
          col:1,
          placeholder:'更新',
          execCallback:this.verifyNSOrdSynced,
          waitClick:true,
          title:'給負責確認拋單到NS的人用的,檢查排程已拋NS的訂單是否已入NS,左邊已拋是配合此情境,勾起來再按查詢的話就只會計算要拋NS的外部訂單數與總金額(特成專用)'
        },
        {
          componentType:'b-button',
          col:1,
          placeholder:'查詢',
          execCallback:this.searchOrders,
          //按鈕用waitClick比較好,但這個function需要多型,所以就不設了(不然就要多跳一層function)
          //waitClick:true,
        }
      ],
      //檢視訂單明細時把items往此陣列塞
      view_order_items:[],
      view_order_type:'',
      showFilter: true,
      modalShow: false,
      items: [],
      pageNumber:0,
      itemsPerPage:50,
      hasMore:true,
      isLoading:false,
      order_item_fields:[
        {
          key: 'item_type',
          label: '類型',
        },
        {
          key: 'item_name',
          label: '品項名稱',
        },
        {
          key: 'product_id',
          label: 'product_id',
        },
         {
          key: 'ns_product_id',
          label: 'NI',
        },
        {
          key: 'item_sale_price',
          label: '單價',
        },
        {
          key: 'item_amount',
          label: '數量',
        },
        {
          key: 'show_tickets',
          label: '票券',
        },
      ],
      fields: [
        {
          key: 'order_id',
          label: '訂單編號',
          sortable: false,
        },
        {
          key: 'paper_way',
          label: '類型',
          sortable: false
        },
        {
          key: 'user_name',
          label: '購買人',
          sortable: false
        },
        {
          key: 'member_id',
          label: '購買人MI',
          sortable: true
        },
        {
          key:'total_amount',
          label:'訂單總金額',
        },
        {
          key:'total_discount_amount',
          label:'訂單折扣',
        },
        {
          key:'order_status',
          label:'狀態',
        },
        {
          key: "ns_so_id",
          label: "NS ID"
        },
        {
          key: 'actions',
          label: '功能'
        }
      ],
      current_tickets:[],
      in_trash_scan: false,
      trash_ticket_no:'',
      trash_ticket_unique_id:'',
      ticket_editting_mapper: {

      }
    }
  },
  methods: {
    cancelTrash(row, ticket){
      console.log(row)
      ticket.is_canceling = false
      ticket = JSON.parse(JSON.stringify(ticket))
      row.item.tickets.push({})
      row.item.tickets.splice(row.item.tickets.length - 1, 1)
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    trash_ticket(ticket,row) {
      console.log('ticket',ticket);
      console.log('row',row);
      this.trash_ticket_no = ticket.ticket_no
      //正確的做法是要先用trash_ticket_no呼叫api檢查正確,拿到ticket_unique_id,再用來作廢,現在是直接作廢
      //先偷懶直接帶進去,讓其可以直接作廢
      this.trash_ticket_unique_id = ticket.ticket_unique_id;

      // 沒信託改用TN票號
      if (!ticket.ticket_no) {
        this.trash_ticket_unique_id = ticket.ticket_id;
      }
      //console.log("trash id", this.trash_ticket_unique_id);
      this.in_trash_scan = true

      this.ticket_editting_mapper[ticket.ticket_unique_id] = {
        "ticket_no": ticket.ticket_no
      }
      ticket.is_canceling = true
      ticket = JSON.parse(JSON.stringify(ticket))
      row.item.tickets.push({})
      row.item.tickets.splice(row.item.tickets.length - 1, 1)

      console.log(ticket)
    },
    confirm_trash() {
      let vm = this
      //用trash_ticket_no作廢票券
      let Param = {
        apiTarget:'ntsa',
        module:'order',
        method:'cancelPaperTicket',
        ticket_unique_ids: this.trash_ticket_unique_id.split(','),
        ticket_ids: this.trash_ticket_unique_id.split(','),
      }

      // 有信託的話
      if (!this.trash_ticket_unique_id.includes('TN')) {
        console.log('信託票號取消')
        apiCancelPaperTicket(Param).then(function(resp){
          vm.$bus.fnShowInfo("作廢成功(要更新畫面狀態請重新查詢)")
        }).catch(function(error){
          let data = error.response.data
          if (data.ok == 0) {
            vm.$bus.fnShowInfo("作廢失敗:"+data.msg)
            return
          }
        })
      }
      // 沒信託的話
      else {
        console.log('無信託票號取消')
        apiCancelSpecialTickets(Param).then(function(resp){
          vm.$bus.fnShowInfo("作廢成功(要更新畫面狀態請重新查詢)")
        }).catch(function(error){
          let data = error.response.data
          if (data.ok == 0) {
            vm.$bus.fnShowInfo("作廢失敗:"+data.msg)
            return
          }
        })
      }
      this.in_trash_scan = false
      // apiCancelPaperTicket(Param).then(function(resp){
      //   vm.$bus.fnShowInfo("作廢成功(要更新畫面狀態請重新查詢)")
      // }).catch(function(error){
      //   let data = error.response.data
      //   if (data.ok == 0) {
      //     vm.$bus.fnShowInfo("作廢失敗:"+data.msg)
      //     return
      //   }
      // })
      
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok == 0) {
      //     vm.$bus.fnShowInfo("作廢失敗:"+data.msg)
      //     return
      //   }
      //   vm.$bus.fnShowInfo("作廢成功(要更新畫面狀態請重新查詢)")
      // }, this)
      // this.in_trash_scan = false
    },
    showTickets(row) {
      row.toggleDetails()
      this.current_tickets = row.item.tickets
    },
    handleScroll(evt) {
      // 僅偵測垂直scroll時是否scroll位置到達95%的位置,是則觸發事件(不能由div觸發需要被捲的組件觸發與偵測＝＝)
      //if ((evt.target.scrollTop/(evt.target.scrollHeight-evt.target.clientHeight)) > 0.95) {
      // 只能把計算邏輯抽到$bus而已,需要this.$refs.scrollarea這個沒辦法丟過去(若為此要把wrapper寫成獨立組件又太麻煩先這樣吧)
      if (this.calScrollRatio(evt) > 0.95) {
        this.$refs.scrollarea.$emit('scrolldownend')
      }
    },
    filterChanged (upd) {
      if (['status','print_type'].includes(upd.key)) {
        setTimeout(() => {
          this.searchOrders()
        }, 50);
      }
    },
    async searchOrders(append = false) {
      
      if (this.isLoading) {
        return
      }
      if (append === true) {
        if (!this.hasMore) {
          return
        }
        this.pageNumber ++
      }
      else {
        this.pageNumber = 1
        this.hasMore = true
        this.$refs.wrapper.scrollTop = 0
      }
      let Param = {
        'apiTarget':'ntsa',
        'module':'order',
        'method':'searchTicketOrders',
        'order_id': this.filterData.order_id.trim(),
        'member_id': this.filterData.member_id.trim(),
        'date_from': this.filterData.date_from?this.filterData.date_from:'',
        'date_to': this.filterData.date_to?this.filterData.date_to:'',
        'status': this.filterData.status,
        'print_type': this.filterData.print_type,
        'page_number':this.pageNumber,
        'items_per_page':this.itemsPerPage,
      }
      this.isLoading = true
      let vm = this
      apiSearchTicketOrders(Param).then(function(resp){
        let data = resp.data
        if (vm.pageNumber === 1) {
          vm.items = data.data
          let total = 0
          if (data.data.length > 0) {
            total = data.data[0].total
          }
          vm.filterData.total = '共'+total+'筆'
          //vm.$refs.filterForm.refreshModelVar('total')
        }
        else {
          vm.items = vm.items.concat(data.data)
        }
        if (data.data.length < vm.itemsPerPage) {
          vm.hasMore = false
        }
        let sum = 0
        let ord_count = 0
        for (let x=0;x<vm.items.length;x++) {
          if (vm.items[x].order_status == 'completed' || vm.items[x].order_status == 'printed_to_deliver') {
            //勾了限已拋,只計算外部訂單已拋數
            if (!vm.filterData.cal_only_synced || vm.items[x].ext_ns_synced == 2) {
              sum += (vm.items[x].total_amount-vm.items[x].total_discount_amount)
              ord_count++
            }
          }
        }
        vm.filterData.ord_amt_sum = '有效訂單金額:'+sum+' 訂單數:'+ord_count
          vm.$refs.filterForm.refreshModelVar('ord_amt_sum')
        
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })
      vm.isLoading = false
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   if (vm.pageNumber === 1) {
      //     vm.items = data.data
      //     let total = 0
      //     if (data.data.length > 0) {
      //       total = data.data[0].total
      //     }
      //     vm.filterData.total = '共'+total+'筆'
      //     //vm.$refs.filterForm.refreshModelVar('total')
      //   }
      //   else {
      //     vm.items = vm.items.concat(data.data)
      //   }
      //   if (data.data.length < vm.itemsPerPage) {
      //     vm.hasMore = false
      //   }
      //   let sum = 0
      //   let ord_count = 0
      //   for (let x=0;x<vm.items.length;x++) {
      //     if (vm.items[x].order_status == 'completed' || vm.items[x].order_status == 'printed_to_deliver') {
      //       //勾了限已拋,只計算外部訂單已拋數
      //       if (!vm.filterData.cal_only_synced || vm.items[x].ext_ns_synced == 2) {
      //         sum += (vm.items[x].total_amount-vm.items[x].total_discount_amount)
      //         ord_count++
      //       }
      //     }
      //   }
      //   vm.filterData.ord_amt_sum = '有效訂單金額:'+sum+' 訂單數:'+ord_count
      //     vm.$refs.filterForm.refreshModelVar('ord_amt_sum')
      //   vm.isLoading = false
      // }, this)
    },
    verifyNSOrdSynced(doneCB = null) {
      let Param = {
        'apiTarget':'ntsa',
        'module':'order',
        'method':'verifyNSOrdSynced',
      }
      let wait_verify_ids = []
      for (let x=0;x<this.items.length;x++){
        //把目前畫面上所有訂單中,ns_synced=1的都撈出來,組ExtraBillIds去查詢是否已入NS,若已入NS更新為已入NS
        //還沒拋的不用抓,已經確認匯入的不用重檢查
        if (this.items[x].ext_ns_synced == 1) {
          wait_verify_ids.push(this.items[x].order_id)
        }
      }
      Param.verify_order_ids = wait_verify_ids.join(',')
      let vm = this
      this.isLoading = true

      apiVerifyNSOrdSynced(Param).then(function(resp){
        let data = resp.data
        //確認過匯入成功的,vm.items要更新ext_ns_synced值至2
        let updated = 0
        for (let y=0;y<vm.items.length;y++) {
          if (data.data.hasOwnProperty(vm.items[y].order_id)) {
            updated++
            vm.items[y].ext_ns_synced = data.data[vm.items[y].order_id]
          }
        }
        vm.$forceUpdate()
        if (updated) {
          vm.$bus.fnShowInfo('已確認更新'+updated+'筆訂單確認已入NS')
        }
        doneCB()
        vm.isLoading = false
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          vm.isLoading = false
          doneCB()
          return
        }
      })

      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     doneCB()
      //     return
      //   }
      //   //確認過匯入成功的,vm.items要更新ext_ns_synced值至2
      //   let updated = 0
      //   for (let y=0;y<vm.items.length;y++) {
      //     if (data.data.hasOwnProperty(vm.items[y].order_id)) {
      //       updated++
      //       vm.items[y].ext_ns_synced = data.data[vm.items[y].order_id]
      //     }
      //   }
      //   vm.$forceUpdate()
      //   if (updated) {
      //     vm.$bus.fnShowInfo('已確認更新'+updated+'筆訂單確認已入NS')
      //   }
      //   doneCB()
      //   vm.isLoading = false
      // }, this)
    },
    do_cancel_order(item) {
      console.log(item);
      let ticket_unique_ids_arr = [];
      item.order_items.forEach(ord_item => 
      {
        if (ord_item.item_type == 'ticket_item') {
          for (let x=0; x< ord_item.tickets.length;x++) {
            if (ord_item.tickets[x].confirm_use_status != 'cancelled') {
              ticket_unique_ids_arr.push(ord_item.tickets[x].ticket_unique_id);
            }
          }
        }
      });
      let ticket_unique_ids_str = ticket_unique_ids_arr.join(',');
      console.log('ticket_unique_ids_str',ticket_unique_ids_str)
      let Param = {
        'apiTarget':'ntsa',
        'module':'order',
        'method':'cancelTickets',
        'ticket_unique_ids': ticket_unique_ids_str.split(',')
      }
      this.isLoading = true
      let vm = this
      // apiCancelTickets(Param).then(function(resp){
      //   vm.$bus.fnShowInfo('取消成功，請重新查詢刷新')
      // }).catch(function(error){
      //   let data = error.response.data
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     return
      //   }
      // })
      vm.isLoading = false
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   vm.$bus.fnShowInfo('取消成功，請重新查詢刷新')
      //   vm.isLoading = false
      // }, this)
    },
    cancelOrder(item) {
      this.$bus.fnShowConfirm(('已信託之訂單票券作廢後將無法恢復，是否確認？'),() => {
        this.do_cancel_order(item)
        this.$bus.fnClosePopup()
        return
      }, () => {
        this.$bus.fnClosePopup()
        return 
      })
    },
    restartOrder(item) {
      //restartFailedOrder
      let Param = {
        'apiTarget':'ntsa',
        'module':'order',
        'method':'restartFailedOrder',
        'ticket_order_id': item.id
      }
      this.isLoading = true
      let vm = this
      apiRestartFailedOrder(Param).then(function(resp){
        vm.$bus.fnShowInfo('已設置重新處理')
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })
      vm.isLoading = false
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   vm.$bus.fnShowInfo('已設置重新處理')
      //   vm.isLoading = false
      // }, this)
    },
    reSyncExtOrdToNS(item) {
      let Param = {
        'apiTarget':'ntsa',
        'module':'order',
        'method':'reSyncExtOrdToNS',
        'order_id': item.order_id
      }
      this.isLoading = true
      let vm = this
      apiReSyncExtOrdToNS(Param).then(function(resp){
        if (item.ext_ns_synced == 0) {
          vm.$bus.fnShowInfo('已手動送出此訂單拋轉NS')
      }
        else {
          vm.$bus.fnShowInfo('已嘗試重新拋此訂單至NS')
        }
      }).catch(function(error){
        let data = error.response.data
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
      })
      vm.isLoading = false
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //     vm.$bus.fnShowInfo(data.msg)
      //     vm.isLoading = false
      //     return
      //   }
      //   if (item.ext_ns_synced == 0) {
      //     vm.$bus.fnShowInfo('已手動送出此訂單拋轉NS')
      // }
      //   else {
      //     vm.$bus.fnShowInfo('已嘗試重新拋此訂單至NS')
      //   }
      //   vm.isLoading = false
      // }, this)
    },
    showDetail: function (row) {
      this.view_order_items = row.order_items
      console.log(this.view_order_items)
      this.view_order_items.forEach(function(order_item){
        console.log(order_item)
        let tickets = order_item.tickets
        if (tickets !== undefined) {
          tickets.forEach(function(ticket){
            console.log(ticket)
            ticket['is_canceling'] = false
          })
        }
      })
      this.view_order_type = row.paper_way
      this.view_is_shopline_order = row.is_shopline_order
      this.modalShow = true
    },
    modalCancel: function () {
      this.modalShow = false
    },
  },
  created() {
    
  },
  async mounted() {
    this.isLoading = true;
    this.$refs.filterForm.initDefault()
    setTimeout(async () => {
      this.isLoading = false
      //第一次的自動載入要等isLoading變false後再跑,不然網速比較快時查詢就被isLoading擋住而沒執行了
      console.log('order_page', window.location.pathname)
      if (window.location.href.indexOf('order_id') !== -1){
        let order_id = ''
        let queryString = window.location.search;
        let urlParams = new URLSearchParams(queryString);
        order_id = urlParams.get('order_id')
        console.log(order_id)
        this.filterData.order_id = order_id
      }
      else if(window.location.href.indexOf('#') !== -1 ) {
        let order_id = window.location.href.split('/#/')[1].split('/')[1]
        this.filterData.order_id = order_id
      }
      else {
        console.log(window.location.href)
      }
      await this.searchOrders()
      window.history.pushState(document.title, document.title, window.location.pathname + window.location.search);
      this.filterData.order_id = ''
      // let optional_hash = location.hash.indexOf('?')!==-1?location.hash.substr(0,location.hash.indexOf('?')):location.hash
      // this.resetUrlQuery(optional_hash)    
    }, 200);
    //不要自動撈全部,需要的自己下條件抓就好(無條件時查詢全部票券很耗資源,select total就需要近一秒)
    //this.searchTickets()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper2 {
  height: 65vh;
  overflow-y: scroll;
  border-style: inset;
}

</style>
